export const SUPPLIER_INSTALLATION_NAME_MAX_LENGTH = 256

export function isSupplierInstallationNameTooLong(name: string): boolean {
  return name.length > SUPPLIER_INSTALLATION_NAME_MAX_LENGTH
}

export function isSupplierInstallationNameValid(name: string): boolean {
  const trimmed = name.trim()
  return trimmed.length > 0 && !isSupplierInstallationNameTooLong(name)
}
